import React from 'react';

const Svg = ({ svg, width, alt, title }) => {
  return (
    <img
      alt={alt || ''}
      title={title}
      role={alt ? null : 'presentation'}
      style={{ width }}
      src={svg}
    />
  );
};

export default Svg;
